"use strict";
/**
 * https://www.figma.com/file/GXtg4B5Uy32yVEBVUJahQF/%F0%9F%90%A5-NEW-DESIGN-SYSTEM?node-id=8820-54578&t=0KKeOxWFespPoB1I-4
 */
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = require("../colors");
const switchTokens = {
    'switch-thumb-bg': (0, colors_1.getColorValue)('white'),
    'switch-thumb-bg-checked': (0, colors_1.getColorValue)('white'),
    'switch-thumb-bg-checked-disabled': (0, colors_1.getColorValue)('white'),
    'switch-thumb-bg-disabled': (0, colors_1.getColorValue)('white'),
    'switch-track-bg': (0, colors_1.getColorValue)('grey.500'),
    'switch-track-bg-checked': (0, colors_1.getColorValue)('grey.800'),
    'switch-track-bg-checked-disabled': (0, colors_1.getColorValue)('grey.400'),
    'switch-track-bg-disabled': (0, colors_1.getColorValue)('grey.300'),
};
exports.default = switchTokens;
